module.exports = __webpack_public_path__ + "static/media/Visa.e07d0bbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/bank/Visa.png
// module id = 294
// module chunks = 0